document.addEventListener(
  "DOMContentLoaded",
  initProductFeatureMoreInfoButtons
);

function initProductFeatureMoreInfoButtons() {
  const moreInfoButtons = document.querySelectorAll(
    ".boa-product-feature-icons-container .feature-more-info-button"
  );
  moreInfoButtons.forEach((showModalButton) => {
    const textDialog = showModalButton
      .closest(".boa-product-feature-icons-container")
      .querySelector(".feature-more-info-text-dialog");
    showModalButton.addEventListener("click", () => {
      const { moreInfoText } = showModalButton.dataset;
      textDialog.querySelector(".text-box").textContent = moreInfoText;
      textDialog.style.top = showModalButton.offsetTop + "px";
      textDialog.showModal();
      if (!isMobileScreenSize()) {
        textDialog.style.left = showModalButton.offsetLeft + "px";
        textDialog.style.top =
          showModalButton.offsetTop - textDialog.offsetHeight + "px";
      }
    });

    const dismissButton = textDialog?.querySelector(".dismiss-button");
    dismissButton?.addEventListener("click", () => {
      textDialog.close();
    });
  });
}

function isMobileScreenSize() {
  const mobileMediaQuery = "(max-width: 767px)";
  return window.matchMedia(mobileMediaQuery).matches;
}
